import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useCard} from '../hooks/useCard';
import {Card} from '../types';
import {useParams} from 'react-router-dom';

export const AddFormDrawer = (props: DrawerProps) => {

    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter');
    }

    const {createRecord} = useCard(customerId);

    return (
        <FormDrawer
            record={{
                id: '',
                customerId: customerId,
            } as Card}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
